import ajax from "@/lib/ajax";

/// <summary>
/// 修改系统配置项
/// </summary>
/// <param name="input"></param>
/// <returns></returns>
export async function ChangeSettings(payload: any) {
	let res = await ajax.post(
		"/api/services/app/Configuration/ChangeSettings",
		payload
	);
	return res.data.result;
}

/// <summary>
/// 读取所有配置项
/// </summary>
/// <param name="input"></param>
/// <returns></returns>
export async function GetSettings() {
	let res = await ajax.get("/api/services/app/Configuration/GetSettings", {});
	return res.data.result;
}

/// <summary>
/// 读取所有配置项
/// </summary>
/// <param name="input"></param>
/// <returns></returns>
export async function GetFormsEnabled() {
	let res = await ajax.get("/api/services/app/Configuration/GetFormsEnabled", {});
	return res.data.result;
}



// WEBPACK FOOTER //
// ./src/api/configuration/index.ts